module.exports = __webpack_public_path__ + "media/文旌教学平台宣传片.5fd00406.mp4";